import { render, staticRenderFns } from "./BuildingType.vue?vue&type=template&id=2ca95431&scoped=true&"
import script from "./BuildingType.vue?vue&type=script&lang=js&"
export * from "./BuildingType.vue?vue&type=script&lang=js&"
import style0 from "./BuildingType.vue?vue&type=style&index=0&id=2ca95431&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca95431",
  null
  
)

export default component.exports